import LoadingScreen from "./LoadingScreen.jsx";
import {useDispatch, useSelector} from "react-redux";
import {useAuth} from "react-oidc-context";
import {useEffect, Suspense} from "react";
import Typography from "@mui/material/Typography";
import {Outlet} from "react-router-dom";
import {login} from "../store/features/app/appActions.js";

export const RequireUser = () => {
    const dispatch = useDispatch()
    const {user} = useAuth()
    const {isAuthed, loading} = useSelector(state => state.app)

    useEffect(() => {
        if(!user) return
        void dispatch(login(user))
    }, [user, dispatch])

    if (loading) return <LoadingScreen>
        <Typography>Loading user data</Typography>
    </LoadingScreen>

    if (isAuthed) return <Suspense fallback={<LoadingScreen />}><Outlet /></Suspense>

    return <Typography>This should not have happened. Please refresh your page.</Typography>
}